const STORAGE_KEY = 'clientType'
const LANGUAGE_STORAGE_KEY = 'clientLanguage'
// Language picked with the flag switcher - wins over the ?language= URL param.
// Kept per session, so every fresh launch starts in the client's default language.
const LANGUAGE_PREFERENCE_KEY = 'clientLanguagePreference'
const DEFAULT_CLIENT = 'bestway'
const VALID_CLIENTS = ['bestway', 'gastro', 'salvia']
const VALID_LANGUAGES = ['pl', 'en']

// Previous builds persisted the language in localStorage - with language-dependent brands
// (Bestway EN / Salvia PL) a stale value would change the brand of every later launch
localStorage.removeItem(LANGUAGE_PREFERENCE_KEY)
localStorage.removeItem(LANGUAGE_STORAGE_KEY)

export const getClientType = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const typeFromUrl = urlParams.get('type')

  if (typeFromUrl && VALID_CLIENTS.includes(typeFromUrl)) {
    localStorage.setItem(STORAGE_KEY, typeFromUrl)
    return typeFromUrl
  }

  const storedType = localStorage.getItem(STORAGE_KEY)
  if (storedType && VALID_CLIENTS.includes(storedType)) {
    return storedType
  }

  return DEFAULT_CLIENT
}

export const getLanguageOverride = () => {
  const preferredLanguage = sessionStorage.getItem(LANGUAGE_PREFERENCE_KEY)
  if (preferredLanguage && VALID_LANGUAGES.includes(preferredLanguage)) {
    return preferredLanguage
  }

  const urlParams = new URLSearchParams(window.location.search)
  const langFromUrl = urlParams.get('language')

  if (langFromUrl && VALID_LANGUAGES.includes(langFromUrl)) {
    return langFromUrl
  }

  return null
}

export const setLanguagePreference = (language) => {
  if (VALID_LANGUAGES.includes(language)) {
    sessionStorage.setItem(LANGUAGE_PREFERENCE_KEY, language)
  }
}
